import React, { useCallback, useEffect, useRef } from 'react';
import {
  FiMail,
  FiUser,
  // FiLock,
  // FiArrowLeftCircle,
} from 'react-icons/fi';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import { useDispatch, useSelector } from 'react-redux';
import getValidationErrors from '../../utils/getValidationErrors';

import Input from '../../components/Input';
import Button from '../../components/Button';

import {
  Container,
  Content,
  AnimationContainer,
  Title,
  ColInput,
} from './styles';
import {
  setIsCategory,
  setMessageToast,
  viewModal,
} from '../../store/modules/parameter/actions';

import SignUpStep01 from './SignUpStep01';
import { CustomerData, AuthActionStep } from '../../store/modules/auth/types';
import {
  customerClear,
  verifyCustomerIsExist,
} from '../../store/modules/auth/actions';
import { StoreState } from '../../store/createStore';
import { useTranslation } from '../../hooks/useTranslation';
import {config as Config} from '../../config';

const SignUp: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { onTranslation: t } = useTranslation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setIsCategory(false));
  }, [dispatch]);

  const { error, message, step, userCreate } = useSelector(
    (state: StoreState) => state.auth,
  );

  const handleSubmit = useCallback(
    async (data: CustomerData) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          first_name: Yup.string().required(
            t('main.messages_yup.name_required'),
          ),
          last_name: Yup.string().required(
            t('main.messages_yup.last_name_required'),
          ),
          email: Yup.string()
            .required(t('main.messages_yup.email_required'))
            .email(t('main.messages_yup.email_invalid')),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        // data.password = 'mudar123';
        // data.status = 0;
        // //konsole.log('SignUp handleSubmit: ', data);
        // dispatch(customerCreateRequest(data, AuthActionStep.CST_STEP_02));
        dispatch(
          verifyCustomerIsExist(
            data,
            AuthActionStep.CST_STEP_02,
            t('main.messages_toast.customer_is_exist'),
          ),
        );
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }
      }
    },
    [formRef, dispatch, t],
  );

  useEffect(() => {
    if (error && message && message !== '') {
      dispatch(setMessageToast({
        type: 'error', message
      }));
    }
  }, [error, message, dispatch]);

  useEffect(() => {
    //konsole.log('useEffect message: ', message);
    if (step === 'CST_STEP_02') {
      dispatch(customerClear());
      dispatch(viewModal(SignUpStep01, { width: '50%', height: '100%' }));
    }
  }, [step, dispatch]);

    useEffect(() => {
      if (formRef.current && userCreate.first_name) {
        //konsole.log('carrega...', address);
        formRef.current.setData({
          first_name: userCreate.first_name,
          last_name: userCreate.last_name,
          email: userCreate.email,
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return (
    <Container>
      <Content>
        <AnimationContainer>
          <img src={Config.logo} alt="ConectoVarejo" />

          <Form
            // initialData={{
            //   first_name: 'Wilson',
            //   last_name: 'Felix',
            //   email: 'wfelix@conecto.com.br',
            // }}
            ref={formRef}
            onSubmit={handleSubmit}
          >
            <Title>
              <span>{t('main.modal_signup.want_to_signup')}</span>
            </Title>

            <ColInput>
              <div style={{ marginBottom: '30px' }} />
            </ColInput>

            <ColInput>
              <Input
                icon={FiUser}
                name="first_name"
                textLabel={t('main.modal_signup.input_name')}
                formRef={formRef}
              />
              <Input
                icon={FiUser}
                name="last_name"
                textLabel={t('main.modal_signup.input_last_name')}
                formRef={formRef}
              />
            </ColInput>

            <ColInput>
              <Input
                icon={FiMail}
                name="email"
                textLabel={t('main.modal_signup.input_email')}
                formRef={formRef}
              />
            </ColInput>

            <ColInput>
              <Button
                button={{ type: 'submit' }}
                atributes={{
                  buttonType: 'primary',
                  textColor: '#fff',
                  textSize: '30px',
                  borderColor: '#dddddd',
                }}
              >
                {t('main.modal_signup.button_signup')}
              </Button>
            </ColInput>
          </Form>
        </AnimationContainer>
      </Content>
    </Container>
  );
};

export default SignUp;
